var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button } from "../../Button";
import { useForm } from "../../../hooks/UseForm";
import { inputFields, initialState, getQueryParams, basicLoginFormValidation, } from "./data-hanlders";
import Styled from "./style";
import { ErrorMessage } from "../../ErrorMessage";
import appConfig from "../../../assests/config";
import { AuthenticationScreens } from "../data";
export const loginHandles = [AuthenticationScreens.login];
const LoginComponent = (props) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [error, setError] = useState("");
    const [fieldReadOnly, setFieldReadOnly] = useState(true);
    const { onChange, onSubmit, values } = useForm(loginUserCallback, initialState);
    const updateValuesFromURL = () => {
        const getValuesFromURL = getQueryParams();
        getValuesFromURL.forEach((credential) => {
            onChange(credential);
        });
        if (!getValuesFromURL.length)
            return;
        const submitValues = getValuesFromURL.reduce((acc, { target }) => (Object.assign(Object.assign({}, acc), { [target.name]: target.value })), {});
        loginUserCallback({ submitValues });
    };
    useEffect(() => {
        updateValuesFromURL();
        const timer = setTimeout(() => {
            setFieldReadOnly(false);
            clearTimeout(timer);
        }, 1000);
    }, []);
    // a submit function that will execute upon form submission
    function loginUserCallback(e) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // authenticationFlow()
                /**
                 * It will validate about the length of the value as per requirement
                 */
                if (basicLoginFormValidation(e.submitValues || values))
                    return setError("Please provide valid details");
                yield props.authenticationFlow(e.submitValues || values);
            }
            catch (error) {
                setError((error === null || error === void 0 ? void 0 : error.message) || appConfig.errorMessages.SOMETHING_WRONG);
            }
        });
    }
    const changeConfig = (navigateTo) => () => {
        props.changeConfig(navigateTo);
    };
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const applyAgencyUI = props.UI === "agency";
    return (React.createElement(Styled, { className: `${applyAgencyUI ? "agency-login" : "login"}` },
        error ? React.createElement(ErrorMessage, { error: error }) : null,
        applyAgencyUI ? (React.createElement("p", { className: "sign-in-text" }, "Sign in with your email and password")) : null,
        React.createElement("section", null,
            React.createElement("form", { onSubmit: onSubmit },
                React.createElement(OutlinedInput, Object.assign({}, inputFields.email, { readOnly: fieldReadOnly, value: values.email, onChange: onChange })),
                React.createElement(FormControl, null,
                    React.createElement(OutlinedInput, Object.assign({}, inputFields.password, { type: showPassword ? "text" : "password", value: values.password, readOnly: fieldReadOnly, onChange: onChange, endAdornment: React.createElement(InputAdornment, { position: "end" },
                            React.createElement(IconButton, { "aria-label": "toggle password visibility", onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, edge: "end", sx: { backgroundColor: "transparent !important" } }, !showPassword ? React.createElement(VisibilityOff, null) : React.createElement(Visibility, null))) })),
                    React.createElement(Button, Object.assign({}, inputFields.forgotPassword, { onClick: changeConfig(AuthenticationScreens.FP) }))),
                React.createElement(Button, Object.assign({}, inputFields.signIn)))),
        applyAgencyUI ? null : (React.createElement("div", { className: "login_please-check" },
            React.createElement("p", null,
                React.createElement("span", null, "Having trouble logging in?"),
                React.createElement("br", null),
                React.createElement(Button, Object.assign({}, inputFields.checkRegistration, { onClick: changeConfig(AuthenticationScreens.CR) })),
                React.createElement("span", null, " if your email has been registered on the portal."))))));
};
export const Login = React.memo(LoginComponent);
